// extracted by mini-css-extract-plugin
module.exports = {"filterSwitch":"General_filterSwitch__2pBU9"};